@defer (on viewport) {
  @if (!isDesktop) {
    <ngx-app-bar
      [title]="'فروشگاه‌های حضوری'"
      [rightButton]="{ mode: 'icon-only', size: 'small', style: 'link', icon: 'arrow-right' }"
      (onRightButtonClick)="goBack()"
    ></ngx-app-bar>
  }
  <div
    [ngClass]="{ 'is-mobile': !isDesktop }"
    class="d-flex store-map-layout"
  >
    <!-- Map -->
    <div class="map-section">
      <lib-shared-common-map
        [points]="points()"
        [currentLocation]="currentLocation()"
        (areaChanged)="onAreaChange($event)"
        (pointSelected)="onPointSelect($event)"
      ></lib-shared-common-map>
    </div>
    <!-- End Map -->
    @if (isDesktop) {
      <stores-applet-store-desktop-map-list-overlay
        [loadingMode]="loadingBranches()"
        [branchesToShow]="branchesListToShow()"
        [totalAvailableStores]="totalAvailableItems()"
        [selectedBranch]="selectedBranch()"
        (goBackClicked)="handleBackBtn()"
        (selectedBranchChange)="goToStoreShop($event!)"
      ></stores-applet-store-desktop-map-list-overlay>
    } @else {
      <stores-applet-mobile-map-list-overlay
        [loadingMode]="loadingBranches()"
        [branchesToShow]="branchesToShowInCarousel()"
        [totalAvailableStores]="totalAvailableItems()"
        [selectedBranch]="selectedBranch()"
        (selectedBranchChange)="goToStoreShop($event!)"
        (goBackClicked)="handleBackBtn()"
      >
      </stores-applet-mobile-map-list-overlay>
    }
  </div>
} @placeholder {
  <span></span>
}
